module.exports = __webpack_public_path__ + "img/dial-off.396ca302.svg";